<template>
  <div class="RoomStatus">
    <div v-if="pageLoading" class="loading">
      <img src="../../image/loading.gif" alt="" />
    </div>
    <el-form
      v-show="!pageLoading"
      :inline="true"
      :model="formInline"
      class="demo-form-inline"
    >
      <el-form-item label="输入查询：">
        <el-input
          v-model="formInline.title"
          placeholder="请输入房源标题"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="房型查询：" class="left_margin">
        <el-select v-model="formInline.number" placeholder="请选择房型" clearable>
          <el-option label="1室" value="1"></el-option>
          <el-option label="2室" value="2"></el-option>
          <el-option label="3室" value="3"></el-option>
          <el-option label="4室" value="4"></el-option>
          <el-option label="5室及以上" value="5"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="left_margin">
        <el-button type="primary" @click="onSubmit" class="inquire"
          >搜索</el-button
        >
        <el-button type="primary" class="reset" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="main" v-show="!pageLoading">
      <div class="content">
        <div class="right">
          <div @click="goToday" class="go-today">今天</div>
          <div class="rooms-info">
            <!-- 左边的房源列表 -->
            <div class="title">
              <div class="title_left">房间</div>
              <div class="title_right">基础价格</div>
            </div>

            <div
              id="rooms-list"
              class="rooms-list"
              ref="systemForm"
              @scroll="sysHandleScroll()"
              @mouseover="changeFlag(1)"
            >
              <div
                @click="housrInfo(item2)"
                v-for="(item2, i) in gridData"
                :key="'item2-' + i"
                class="room-item"
              >
                <div class="roomTitle">
                    <div class="room-item-text">
                        {{ item2.nickName || item2.name }}
                    </div>
                    <img v-if="item2.iChannelId==0" class="channelImg" src="@/image/youjia.png"/>
                    <img v-if="item2.iChannelId==1" class="channelImg" src="@/image/mt.png"/>
                    <img v-if="item2.iChannelId==2" class="channelImg" src="@/image/tj.png"/>
                    <img v-if="item2.iChannelId==3" class="channelImg" src="@/image/pig.png"/>
                    <img v-if="item2.iChannelId==4" class="channelImg" src="@/image/ai.png"/>
                </div>
                <div class="room-item-price">
                  <div class="money">
                    {{ item2.mDailyChannel || "暂无" }}
                  </div>
                  <div class="money_currency">CNY</div>
                </div>
              </div>
            </div>
          </div>
          <!-- 上面的日期 -->
          <div id="room-status" class="room-status">
            <div
              :style="{
                width: daysDATA.totalDay * daysDATA.multiple * gridWidth + 'px'
              }"
              class="calendar"
            >
              <div
                :style="{ width: gridWidth + 'px' }"
                :data-item="'day-' + item.date"
                v-for="(item, index) in days"
                :key="index"
              >
                <div class="day">
                  <div v-if="item.isHolidays" class="isHolidays">
                    <img src="../../image/xiu.png" alt="" />
                  </div>
                  <div v-if="item.isWeekdays" class="isHolidays">
                    <img src="../../image/ban.png" alt="" />
                  </div>
                  {{ item.month }}-{{ item.day }}
                </div>

                <div
                  v-if="!item.isToday"
                  :class="{ weekend: item.isWeek }"
                  class="week"
                >
                  {{ item.weekStr }}
                </div>
                <div v-if="item.isToday" class="today">
                  今天
                </div>

                <div class="surplus">余{{item.houseNum||houseNum}}</div>
              </div>
            </div>
            <!-- 下面的list -->

            <div
              id="rooms"
              :style="{
                width: daysDATA.totalDay * daysDATA.multiple * gridWidth + 'px'
              }"
              class="rooms"
              ref="externalForm"
              @scroll="exterHandleScroll()"
              @mouseover="changeFlag(2)"
            >
              <div
                v-if="selectBoxShow"
                :style="{
                  left: selectBoxPosition.left + 'px',
                  top: selectBoxPosition.top + 'px',
                  width: selectBoxPosition.max - selectBoxPosition.min + 'px'
                }"
                class="select-box"
              ></div>
              <div
                class="rooms-line"
                v-for="(item, y) in gridData"
                :key="item.id"
              >
                <div v-for="(item2, x) in item.children" :key="x">
                  <div
                    id="rooms-line-box"
                    :class="{
                      'rooms-pitch': item2._isSelect
                    }"
                    class="rooms-item"
                    :style="{
                      width: gridWidth + 'px',
                      left: x * gridWidth + 'px'
                    }"
                    @mousemove="
                      roomMoveHandle($event, x, y, item2.date, item.id)
                    "
                    @mousedown="
                      roomDownHandle($event, x, y, item2.date, item.id)
                    "
                    @mouseup="roomUpHandle(item2)"
                  >
<!--                    {{ item2._guestInfo || item2._mDailyPrice }}-->
                    {{ item2.mDailyPrices || '' }}
                    <!-- <div class="check-in_top">【{{ "1" }}】</div>
                    <div class="check-in_bottom"></div> -->
                  </div>
                  <!-- iHouseStatus == 0 关房  iHouseStatus ==1 订房 -->
                  <!-- <div
                    class="check-in"
                    :style="{
                      width: gridWidth * item2._guestInfo.iStatusFlag + 'px',
                      left: x * gridWidth + 'px'
                    }"
                    v-if="
                      item2._isBuy &&
                        item2._guestInfo.iHouseStatus == 1 &&
                        item2.begin
                    "
                  ></div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="paging">
      <div class="block">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[8, 15, 20]"
          :page-size="8"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 修改信息弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible_other"
      width="375px"
      :show-close="false"
    >
      <div class="userNickName">
        昵称：
        <div class="userNickName_input">
          <el-input
            v-model="houseIdNickName"
            placeholder="请输入内容"
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible_other = false" class="cancel"
          >取 消</el-button
        >
        <el-button type="primary" @click="save" class="add_new_btn"
          >保 存</el-button
        >
      </span>
    </el-dialog>
    <!-- 信息弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="346px"
      :before-close="handleClose"
      :show-close="false"
    >
      <div class="info">
        <div class="info_top">
          <div class="top_left">
            <img :src="home_img" />
          </div>
          <div class="top_right">
            {{ home_title }}
          </div>
        </div>
        <div class="info_bottom" @click="chengename">
          <div class="bottom_left">昵称：{{ home_title || nickName }}</div>
          <div class="bottom_right">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 侧边弹窗 -->
    <el-drawer
      :visible.sync="drawer"
      :direction="direction"
      :modal="false"
      width="360px"
      :show-close="false"
      :before-close="handleCloseLeft"
    >
      <el-tabs v-model="activeName" @tab-click="TabsClick" stretch>
        <el-tab-pane label="改价" name="first">
          <div class="hoursInfo_box">
            <div class="hoursInfo_title">
              {{selectHouseObj.vChannelTitle}}}
            </div>
<!--            <div class="hoursInfo_message">整套出租丨1室1厅丨2床丨可住2人</div>
            <div class="hoursInfo_message">
              地址：湖北省武汉市黄陂区卓尔企业总部
            </div>-->
            <div class="hoursInfo_date">
              {{ this.selectData[0] || this.noSlects[0] }}~{{
                this.selectData[this.selectData.length - 1] ||
                  this.noSlects[this.noSlects.length - 1]
              }}（共{{
                this.selectData.length == 0
                  ? this.noSlects.length
                  : this.selectData.length
              }}晚）
              <i class="el-input__icon iconfont iconriqixuanze"></i>
            </div>
            <div class="hoursInfo_title">
              改价
              <div>卖价</div>
            </div>
            <!-- 一键改价 -->
            <el-form
              ref="changePrice"
              label-position="left"
              label-width="230px"
              :model="changePrice"
            >
              <el-form-item label="一键改价">
                <el-input
                  oninput="value=value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3')"
                  v-model="changePrice.iPriceNumber"
                  :disabled="
                    this.changePrice.iYoujiaPrice > 0 ||
                      this.changePrice.iMeituanPrice > 0 ||
                      this.changePrice.iTujiaPrice > 0 ||
                      this.changePrice.iXiaozhuPrice > 0 ||
                      this.changePrice.iAibiyinPrice > 0
                  "
                ></el-input>
              </el-form-item>
              <el-form-item label="悠家民宿">
                <el-input
                  oninput="value=value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3')"
                  v-model="changePrice.iYoujiaPrice"
                  :disabled="this.changePrice.iPriceNumber > 0"
                ></el-input>
              </el-form-item>
              <el-form-item label="美团民宿">
                <el-input
                  oninput="value=value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3')"
                  v-model="changePrice.iMeituanPrice"
                  :disabled="this.changePrice.iPriceNumber > 0"
                ></el-input>
              </el-form-item>
              <el-form-item label="途家民宿">
                <el-input
                  oninput="value=value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3')"
                  v-model="changePrice.iTujiaPrice"
                  :disabled="this.changePrice.iPriceNumber > 0"
                ></el-input>
              </el-form-item>
              <el-form-item label="小猪民宿">
                <el-input
                  oninput="value=value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3')"
                  v-model="changePrice.iXiaozhuPrice"
                  :disabled="this.changePrice.iPriceNumber > 0"
                ></el-input>
              </el-form-item>
              <el-form-item label="爱彼迎">
                <el-input
                  oninput="value=value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3')"
                  v-model="changePrice.iAibiyinPrice"
                  :disabled="this.changePrice.iPriceNumber > 0"
                ></el-input>
              </el-form-item>
               <div>
                   <div style="font-size: 14px;">
                       一键同步途家基础房态房价
                   </div>
                   <div style="margin: 10px 0">
                       <el-radio v-model="hasSyncTjPrice" :label="true">是</el-radio>
                       <el-radio v-model="hasSyncTjPrice" :label="false">否</el-radio>
                   </div>

                   <span style="color: #ff0000;font-size: 14px">*选择是后更改房价将不会生效,只同步基础房态房价到途家</span>
               </div>
            </el-form>
            <div class="footer">
              <el-button class="cancel" @click="cancel">取 消</el-button>
              <el-button
                type="primary"
                class="add_new_btn"
                @click="changePricePost"
                >确 定</el-button
              >
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-drawer>
  </div>
</template>

<script>
import {format} from "@/utils/util";

let count = 0;
import {
    housePrice,
    updateHouseNickName,
    RoomaddOrders,
    updateHouseStatus,
    fastUpdatePrice, pigSyncPrice, mtOperateRs, getInventory, inventory
} from "../../api/index";
import { Debounce } from "../../utils/treating";
import {createLogger} from "vuex";
export default {
  data() {
    return {
      houseNum:0,
      houseData:[],
      formInline: {
        title: "",
        number: "",
        cStewardId:sessionStorage.getItem('userId')
      },
      box_width: 0,
      hasSyncTjPrice:false,// 是否同步房价
      changePrice: {
        houseId: "", //房源id
        dPriceStartTime: "", //开始时间
        dPriceEndTime: "", //结束时间
        iPriceNumber: "", //一键改价
        iYoujiaPrice: "", //悠家
        iMeituanPrice: "", //美团
        iTujiaPrice: "", //途家
        iXiaozhuPrice: "", //小猪
        iAibiyinPrice: "", //爱彼迎
        iPriceStatus: "1",
        iChannelIds: [0, 1, 2, 3, 4]
      },
        tjUpdatePriceFrom:{
            "inventorys": [
                {
                    "begin_date": "2023-06-29",
                    "end_date": "2023-07-01",
                    "quantity": 1 //库存写死1
                }
            ],
            "prices": [
                {
                    "amount": 101, //价格
                    "begin_date": "2023-06-29",
                    "end_date": "2023-07-01"
                }
            ],
            "partner_pid": "YJH-0004413", //房间id
            "partner_uid": "YJH-0004413"
        },
      noSlects: [], //已关闭房源
      home_title: "",
      home_img: "",
      houseId: "",
      nickName: "",
      houseIdNickName: "",
      scroll: "",
      ID: "",
      pageLoading: true, //加载时，数据刷新页面是否显示
      daysDATA: {},
      days: [], //？？？？
      oneGoToday: false,
      roomsListTop: 0,
      gridWidth: 50,
      gridData: [],
      infos: [], //订单状态
      // Closeroom:[],//关房状态
      singleList: [],

      gridShowSection: {
        min: 10,
        max: 20
      },
      total: 0,
      currentPage: 1,
      roomsId: null,
      isSelect: false,
      selectBoxShow: false,
        selectDayList:[],//选中的日期
      selectData: [],
      selectDataObj: [],
      selectHouseObj:{},
      selectBoxPosition: {
        left: 0,
        top: 0,
        x: 0,
        y: 0,
        min: 0,
        max: 0
      },
      // 是否显示
      dialogVisible: false,
      dialogVisible_other: false,
      page: {
        year: "2021",
        month: "7",
        Num: "2",
        pageNum: 1,
        pageSize: 8
      },
      te: {
        year: "2021",
        month: "7",
        Num: "3",
        pageNum: 1,
        pageSize: 8
      },
      // 左边弹出框
      drawer: false,
      direction: "rtl",
      activeName: "first"
    };
  },
  created() {
    // this.ID = "18727101380";
    this.housePriceAjax();
  },
  mounted() {
    this.setDaysData();
    window.addEventListener("scroll", this.scrollDs, true);
  },
  watch: {
    gridData() {
      this.$nextTick(() => {
        if (!this.oneGoToday) {
          this.oneGoToday = true;
          setTimeout(() => {
            // 去今天
            this.goToday();
            this.pageLoading = false; //页面刷新直接跳转到今天
            console.log(
              `全部dom渲染已完成,总耗时：${+new Date() -
                this.daysDATA.todayMs}ms`
            );
          }, 10);
        }
      });
    }
  },
  methods: {
    scrollDs() {
      this.roomStatusLeft = document.getElementById("room-status").scrollLeft;
      const toDay = new Date(); //34421,
      console.log(toDay);
      console.log(this.roomStatusLeft, "1");
      if (18200 + 16500 <= this.roomStatusLeft) {
        const num = 12;
        const month = toDay.getMonth();
        const year = toDay.getFullYear();
        if (month + num <= 12) {
          this.te.year = year;
          this.te.month = month + num;
        } else {
          this.te.year = year + 1;
          switch (month + num) {
            case 13:
              this.te.month = 1;
              break;
            case 14:
              this.te.month = 2;
              break;
            case 15:
              this.te.month = 3;
              break;
            case 16:
              this.te.month = 4;
              break;
            case 17:
              this.te.month = 5;
              break;
            case 18:
              this.te.month = 6;
              break;
            case 19:
              this.te.month = 7;
              break;
            case 20:
              this.te.month = 8;
              break;
            case 21:
              this.te.month = 9;
              break;
            case 22:
              this.te.month = 10;
              break;
            case 23:
              this.te.month = 11;
              break;
            case 24:
              this.te.month = 12;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 + 15000 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 + 16500
      ) {
        const num = 11;
        const month = toDay.getMonth();
        const year = toDay.getFullYear();
        if (month + num <= 12) {
          this.te.year = year;
          this.te.month = month + num;
        } else {
          this.te.year = year + 1;
          switch (month + num) {
            case 13:
              this.te.month = 1;
              break;
            case 14:
              this.te.month = 2;
              break;
            case 15:
              this.te.month = 3;
              break;
            case 16:
              this.te.month = 4;
              break;
            case 17:
              this.te.month = 5;
              break;
            case 18:
              this.te.month = 6;
              break;
            case 19:
              this.te.month = 7;
              break;
            case 20:
              this.te.month = 8;
              break;
            case 21:
              this.te.month = 9;
              break;
            case 22:
              this.te.month = 10;
              break;
            case 23:
              this.te.month = 11;
              break;
            case 24:
              this.te.month = 12;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 + 13500 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 + 15000
      ) {
        const num = 10;
        const month = toDay.getMonth();
        const year = toDay.getFullYear();
        if (month + num <= 12) {
          this.te.year = year;
          this.te.month = month + num;
        } else {
          this.te.year = year + 1;
          switch (month + num) {
            case 13:
              this.te.month = 1;
              break;
            case 14:
              this.te.month = 2;
              break;
            case 15:
              this.te.month = 3;
              break;
            case 16:
              this.te.month = 4;
              break;
            case 17:
              this.te.month = 5;
              break;
            case 18:
              this.te.month = 6;
              break;
            case 19:
              this.te.month = 7;
              break;
            case 20:
              this.te.month = 8;
              break;
            case 21:
              this.te.month = 9;
              break;
            case 22:
              this.te.month = 10;
              break;
            case 23:
              this.te.month = 11;
              break;
            case 24:
              this.te.month = 12;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 + 12000 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 + 13500
      ) {
        const num = 9;
        const month = toDay.getMonth();
        const year = toDay.getFullYear();
        if (month + num <= 12) {
          this.te.year = year;
          this.te.month = month + num;
        } else {
          this.te.year = year + 1;
          switch (month + num) {
            case 13:
              this.te.month = 1;
              break;
            case 14:
              this.te.month = 2;
              break;
            case 15:
              this.te.month = 3;
              break;
            case 16:
              this.te.month = 4;
              break;
            case 17:
              this.te.month = 5;
              break;
            case 18:
              this.te.month = 6;
              break;
            case 19:
              this.te.month = 7;
              break;
            case 20:
              this.te.month = 8;
              break;
            case 21:
              this.te.month = 9;
              break;
            case 22:
              this.te.month = 10;
              break;
            case 23:
              this.te.month = 11;
              break;
            case 24:
              this.te.month = 12;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 + 10500 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 + 12000
      ) {
        const num = 8;
        const month = toDay.getMonth();
        const year = toDay.getFullYear();
        if (month + num <= 12) {
          this.te.year = year;
          this.te.month = month + num;
        } else {
          this.te.year = year + 1;
          switch (month + num) {
            case 13:
              this.te.month = 1;
              break;
            case 14:
              this.te.month = 2;
              break;
            case 15:
              this.te.month = 3;
              break;
            case 16:
              this.te.month = 4;
              break;
            case 17:
              this.te.month = 5;
              break;
            case 18:
              this.te.month = 6;
              break;
            case 19:
              this.te.month = 7;
              break;
            case 20:
              this.te.month = 8;
              break;
            case 21:
              this.te.month = 9;
              break;
            case 22:
              this.te.month = 10;
              break;
            case 23:
              this.te.month = 11;
              break;
            case 24:
              this.te.month = 12;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 + 9000 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 + 10500
      ) {
        const num = 7;
        const month = toDay.getMonth();
        const year = toDay.getFullYear();
        if (month + num <= 12) {
          this.te.year = year;
          this.te.month = month + num;
        } else {
          this.te.year = year + 1;
          switch (month + num) {
            case 13:
              this.te.month = 1;
              break;
            case 14:
              this.te.month = 2;
              break;
            case 15:
              this.te.month = 3;
              break;
            case 16:
              this.te.month = 4;
              break;
            case 17:
              this.te.month = 5;
              break;
            case 18:
              this.te.month = 6;
              break;
            case 19:
              this.te.month = 7;
              break;
            case 20:
              this.te.month = 8;
              break;
            case 21:
              this.te.month = 9;
              break;
            case 22:
              this.te.month = 10;
              break;
            case 23:
              this.te.month = 11;
              break;
            case 24:
              this.te.month = 12;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 + 7500 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 + 9000
      ) {
        const num = 6;
        const month = toDay.getMonth();
        const year = toDay.getFullYear();
        if (month + num <= 12) {
          this.te.year = year;
          this.te.month = month + num;
        } else {
          this.te.year = year + 1;
          switch (month + num) {
            case 13:
              this.te.month = 1;
              break;
            case 14:
              this.te.month = 2;
              break;
            case 15:
              this.te.month = 3;
              break;
            case 16:
              this.te.month = 4;
              break;
            case 17:
              this.te.month = 5;
              break;
            case 18:
              this.te.month = 6;
              break;
            case 19:
              this.te.month = 7;
              break;
            case 20:
              this.te.month = 8;
              break;
            case 21:
              this.te.month = 9;
              break;
            case 22:
              this.te.month = 10;
              break;
            case 23:
              this.te.month = 11;
              break;
            case 24:
              this.te.month = 12;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 + 6000 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 + 7500
      ) {
        const num = 5;
        const month = toDay.getMonth();
        const year = toDay.getFullYear();
        if (month + num <= 12) {
          this.te.year = year;
          this.te.month = month + num;
        } else {
          this.te.year = year + 1;
          switch (month + num) {
            case 13:
              this.te.month = 1;
              break;
            case 14:
              this.te.month = 2;
              break;
            case 15:
              this.te.month = 3;
              break;
            case 16:
              this.te.month = 4;
              break;
            case 17:
              this.te.month = 5;
              break;
            case 18:
              this.te.month = 6;
              break;
            case 19:
              this.te.month = 7;
              break;
            case 20:
              this.te.month = 8;
              break;
            case 21:
              this.te.month = 9;
              break;
            case 22:
              this.te.month = 10;
              break;
            case 23:
              this.te.month = 11;
              break;
            case 24:
              this.te.month = 12;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 + 4500 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 + 6000
      ) {
        const num = 4;
        const month = toDay.getMonth();
        const year = toDay.getFullYear();
        if (month + num <= 12) {
          this.te.year = year;
          this.te.month = month + num;
        } else {
          this.te.year = year + 1;
          switch (month + num) {
            case 13:
              this.te.month = 1;
              break;
            case 14:
              this.te.month = 2;
              break;
            case 15:
              this.te.month = 3;
              break;
            case 16:
              this.te.month = 4;
              break;
            case 17:
              this.te.month = 5;
              break;
            case 18:
              this.te.month = 6;
              break;
            case 19:
              this.te.month = 7;
              break;
            case 20:
              this.te.month = 8;
              break;
            case 21:
              this.te.month = 9;
              break;
            case 22:
              this.te.month = 10;
              break;
            case 23:
              this.te.month = 11;
              break;
            case 24:
              this.te.month = 12;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 + 3000 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 + 4500
      ) {
        const num = 3;
        const month = toDay.getMonth();
        const year = toDay.getFullYear();
        if (month + num <= 12) {
          this.te.year = year;
          this.te.month = month + num;
        } else {
          this.te.year = year + 1;
          switch (month + num) {
            case 13:
              this.te.month = 1;
              break;
            case 14:
              this.te.month = 2;
              break;
            case 15:
              this.te.month = 3;
              break;
            case 16:
              this.te.month = 4;
              break;
            case 17:
              this.te.month = 5;
              break;
            case 18:
              this.te.month = 6;
              break;
            case 19:
              this.te.month = 7;
              break;
            case 20:
              this.te.month = 8;
              break;
            case 21:
              this.te.month = 9;
              break;
            case 22:
              this.te.month = 10;
              break;
            case 23:
              this.te.month = 11;
              break;
            case 24:
              this.te.month = 12;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 + 1500 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 + 3000
      ) {
        const num = 2;
        const month = toDay.getMonth();
        const year = toDay.getFullYear();
        if (month + num <= 12) {
          this.te.year = year;
          this.te.month = month + num;
        } else {
          this.te.year = year + 1;
          switch (month + num) {
            case 13:
              this.te.month = 1;
              break;
            case 14:
              this.te.month = 2;
              break;
            case 15:
              this.te.month = 3;
              break;
            case 16:
              this.te.month = 4;
              break;
            case 17:
              this.te.month = 5;
              break;
            case 18:
              this.te.month = 6;
              break;
            case 19:
              this.te.month = 7;
              break;
            case 20:
              this.te.month = 8;
              break;
            case 21:
              this.te.month = 9;
              break;
            case 22:
              this.te.month = 10;
              break;
            case 23:
              this.te.month = 11;
              break;
            case 24:
              this.te.month = 12;
              break;
          }
        }

        this.submit(this.te);
      }
      if (18200 <= this.roomStatusLeft && this.roomStatusLeft < 18200 + 1500) {
        const num = 1;
        const month = toDay.getMonth();
        const year = toDay.getFullYear();
        if (month + num <= 12) {
          this.te.year = year;
          this.te.month = month + num;
        } else {
          this.te.year = year + 1;
          switch (month + num) {
            case 13:
              this.te.month = 1;
              break;
            case 14:
              this.te.month = 2;
              break;
            case 15:
              this.te.month = 3;
              break;
            case 16:
              this.te.month = 4;
              break;
            case 17:
              this.te.month = 5;
              break;
            case 18:
              this.te.month = 6;
              break;
            case 19:
              this.te.month = 7;
              break;
            case 20:
              this.te.month = 8;
              break;
            case 21:
              this.te.month = 9;
              break;
            case 22:
              this.te.month = 10;
              break;
            case 23:
              this.te.month = 11;
              break;
            case 24:
              this.te.month = 12;
              break;
          }
        }

        this.submit(this.te);
      }
      // -------------大于今天的时候End---------------
      //-------------当前月份的时候Start-------------
      if (18200 - 1500 <= this.roomStatusLeft && this.roomStatusLeft < 18200) {
        const num = 0;
        const month = toDay.getMonth();
        const year = toDay.getFullYear();
        if (month + num == month) {
          this.te.year = year;
          this.te.month = month + num;
        }

        this.submit(this.te);
      }
      //-------------当前月份的时候End-------------
      if (
        18200 - 3000 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 - 1500
      ) {
        const num = 1;
        const month = toDay.getMonth();
        const year = toDay.getFullYear();
        if (month - num > 0) {
          this.te.year = year;
          this.te.month = month - num;
        } else {
          this.te.year = year - 1;
          switch (month - num) {
            case 0:
              this.te.month = 12;
              break;
            case -1:
              this.te.month = 11;
              break;
            case -2:
              this.te.month = 10;
              break;
            case -3:
              this.te.month = 9;
              break;
            case -4:
              this.te.month = 8;
              break;
            case -5:
              this.te.month = 7;
              break;
            case -6:
              this.te.month = 6;
              break;
            case -7:
              this.te.month = 5;
              break;
            case -8:
              this.te.month = 4;
              break;
            case -9:
              this.te.month = 3;
              break;
            case -10:
              this.te.month = 2;
              break;
            case -11:
              this.te.month = 1;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 - 4500 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 - 3000
      ) {
        const num = 2;
        const month = toDay.getMonth();
        const year = toDay.getFullYear();
        if (month - num > 0) {
          this.te.year = year;
          this.te.month = month - num;
        } else {
          this.te.year = year - 1;
          switch (month - num) {
            case 0:
              this.te.month = 12;
              break;
            case -1:
              this.te.month = 11;
              break;
            case -2:
              this.te.month = 10;
              break;
            case -3:
              this.te.month = 9;
              break;
            case -4:
              this.te.month = 8;
              break;
            case -5:
              this.te.month = 7;
              break;
            case -6:
              this.te.month = 6;
              break;
            case -7:
              this.te.month = 5;
              break;
            case -8:
              this.te.month = 4;
              break;
            case -9:
              this.te.month = 3;
              break;
            case -10:
              this.te.month = 2;
              break;
            case -11:
              this.te.month = 1;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 - 6000 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 - 4500
      ) {
        const num = 3;
        const month = toDay.getMonth();
        const year = toDay.getFullYear();
        if (month - num > 0) {
          this.te.year = year;
          this.te.month = month - num;
        } else {
          this.te.year = year - 1;
          switch (month - num) {
            case 0:
              this.te.month = 12;
              break;
            case -1:
              this.te.month = 11;
              break;
            case -2:
              this.te.month = 10;
              break;
            case -3:
              this.te.month = 9;
              break;
            case -4:
              this.te.month = 8;
              break;
            case -5:
              this.te.month = 7;
              break;
            case -6:
              this.te.month = 6;
              break;
            case -7:
              this.te.month = 5;
              break;
            case -8:
              this.te.month = 4;
              break;
            case -9:
              this.te.month = 3;
              break;
            case -10:
              this.te.month = 2;
              break;
            case -11:
              this.te.month = 1;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 - 7500 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 - 6000
      ) {
        const num = 4;
        const month = toDay.getMonth();
        const year = toDay.getFullYear();
        if (month - num > 0) {
          this.te.year = year;
          this.te.month = month - num;
        } else {
          this.te.year = year - 1;
          switch (month - num) {
            case 0:
              this.te.month = 12;
              break;
            case -1:
              this.te.month = 11;
              break;
            case -2:
              this.te.month = 10;
              break;
            case -3:
              this.te.month = 9;
              break;
            case -4:
              this.te.month = 8;
              break;
            case -5:
              this.te.month = 7;
              break;
            case -6:
              this.te.month = 6;
              break;
            case -7:
              this.te.month = 5;
              break;
            case -8:
              this.te.month = 4;
              break;
            case -9:
              this.te.month = 3;
              break;
            case -10:
              this.te.month = 2;
              break;
            case -11:
              this.te.month = 1;
              break;
          }
        }
        this.submit(this.te);
      }
      if (
        18200 - 9000 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 - 7500
      ) {
        const num = 5;
        const month = toDay.getMonth();
        const year = toDay.getFullYear();
        if (month - num > 0) {
          this.te.year = year;
          this.te.month = month - num;
        } else {
          this.te.year = year - 1;
          switch (month - num) {
            case 0:
              this.te.month = 12;
              break;
            case -1:
              this.te.month = 11;
              break;
            case -2:
              this.te.month = 10;
              break;
            case -3:
              this.te.month = 9;
              break;
            case -4:
              this.te.month = 8;
              break;
            case -5:
              this.te.month = 7;
              break;
            case -6:
              this.te.month = 6;
              break;
            case -7:
              this.te.month = 5;
              break;
            case -8:
              this.te.month = 4;
              break;
            case -9:
              this.te.month = 3;
              break;
            case -10:
              this.te.month = 2;
              break;
            case -11:
              this.te.month = 1;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 - 10500 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 - 9000
      ) {
        const num = 6;
        const month = toDay.getMonth();
        const year = toDay.getFullYear();
        if (month - num > 0) {
          this.te.year = year;
          this.te.month = month - num;
        } else {
          this.te.year = year - 1;
          switch (month - num) {
            case 0:
              this.te.month = 12;
              break;
            case -1:
              this.te.month = 11;
              break;
            case -2:
              this.te.month = 10;
              break;
            case -3:
              this.te.month = 9;
              break;
            case -4:
              this.te.month = 8;
              break;
            case -5:
              this.te.month = 7;
              break;
            case -6:
              this.te.month = 6;
              break;
            case -7:
              this.te.month = 5;
              break;
            case -8:
              this.te.month = 4;
              break;
            case -9:
              this.te.month = 3;
              break;
            case -10:
              this.te.month = 2;
              break;
            case -11:
              this.te.month = 1;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 - 12000 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 - 10500
      ) {
        const num = 7;
        const month = toDay.getMonth();
        const year = toDay.getFullYear();
        if (month - num > 0) {
          this.te.year = year;
          this.te.month = month - num;
        } else {
          this.te.year = year - 1;
          switch (month - num) {
            case 0:
              this.te.month = 12;
              break;
            case -1:
              this.te.month = 11;
              break;
            case -2:
              this.te.month = 10;
              break;
            case -3:
              this.te.month = 9;
              break;
            case -4:
              this.te.month = 8;
              break;
            case -5:
              this.te.month = 7;
              break;
            case -6:
              this.te.month = 6;
              break;
            case -7:
              this.te.month = 5;
              break;
            case -8:
              this.te.month = 4;
              break;
            case -9:
              this.te.month = 3;
              break;
            case -10:
              this.te.month = 2;
              break;
            case -11:
              this.te.month = 1;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 - 13500 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 - 12000
      ) {
        const num = 8;
        const month = toDay.getMonth();
        const year = toDay.getFullYear();
        if (month - num > 0) {
          this.te.year = year;
          this.te.month = month - num;
        } else {
          this.te.year = year - 1;
          switch (month - num) {
            case 0:
              this.te.month = 12;
              break;
            case -1:
              this.te.month = 11;
              break;
            case -2:
              this.te.month = 10;
              break;
            case -3:
              this.te.month = 9;
              break;
            case -4:
              this.te.month = 8;
              break;
            case -5:
              this.te.month = 7;
              break;
            case -6:
              this.te.month = 6;
              break;
            case -7:
              this.te.month = 5;
              break;
            case -8:
              this.te.month = 4;
              break;
            case -9:
              this.te.month = 3;
              break;
            case -10:
              this.te.month = 2;
              break;
            case -11:
              this.te.month = 1;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 - 15000 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 - 13500
      ) {
        const num = 9;
        const month = toDay.getMonth();
        const year = toDay.getFullYear();
        if (month - num > 0) {
          this.te.year = year;
          this.te.month = month - num;
        } else {
          this.te.year = year - 1;
          switch (month - num) {
            case 0:
              this.te.month = 12;
              break;
            case -1:
              this.te.month = 11;
              break;
            case -2:
              this.te.month = 10;
              break;
            case -3:
              this.te.month = 9;
              break;
            case -4:
              this.te.month = 8;
              break;
            case -5:
              this.te.month = 7;
              break;
            case -6:
              this.te.month = 6;
              break;
            case -7:
              this.te.month = 5;
              break;
            case -8:
              this.te.month = 4;
              break;
            case -9:
              this.te.month = 3;
              break;
            case -10:
              this.te.month = 2;
              break;
            case -11:
              this.te.month = 1;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 - 16500 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 - 15000
      ) {
        const num = 10;
        const month = toDay.getMonth();
        const year = toDay.getFullYear();
        if (month - num > 0) {
          this.te.year = year;
          this.te.month = month - num;
        } else {
          this.te.year = year - 1;
          switch (month - num) {
            case 0:
              this.te.month = 12;
              break;
            case -1:
              this.te.month = 11;
              break;
            case -2:
              this.te.month = 10;
              break;
            case -3:
              this.te.month = 9;
              break;
            case -4:
              this.te.month = 8;
              break;
            case -5:
              this.te.month = 7;
              break;
            case -6:
              this.te.month = 6;
              break;
            case -7:
              this.te.month = 5;
              break;
            case -8:
              this.te.month = 4;
              break;
            case -9:
              this.te.month = 3;
              break;
            case -10:
              this.te.month = 2;
              break;
            case -11:
              this.te.month = 1;
              break;
          }
        }

        this.submit(this.te);
      }
      if (
        18200 - 18200 <= this.roomStatusLeft &&
        this.roomStatusLeft < 18200 - 16500
      ) {
        const num = 11;
        const month = toDay.getMonth();
        const year = toDay.getFullYear();
        if (month - num > 0) {
          this.te.year = year;
          this.te.month = month - num;
        } else {
          this.te.year = year - 1;
          switch (month - num) {
            case 0:
              this.te.month = 12;
              break;
            case -1:
              this.te.month = 11;
              break;
            case -2:
              this.te.month = 10;
              break;
            case -3:
              this.te.month = 9;
              break;
            case -4:
              this.te.month = 8;
              break;
            case -5:
              this.te.month = 7;
              break;
            case -6:
              this.te.month = 6;
              break;
            case -7:
              this.te.month = 5;
              break;
            case -8:
              this.te.month = 4;
              break;
            case -9:
              this.te.month = 3;
              break;
            case -10:
              this.te.month = 2;
              break;
            case -11:
              this.te.month = 1;
              break;
          }
        }
        this.submit(this.te);
      }
    },
    submit: Debounce(function(e) {
      // console.log(e);
      this.housePriceAjax();
    }, 1000),
      getInventory(houseId,title){
          return  getInventory({houseId,title});
      },
      updateTjInventory(dayList,price) {
        let startTime = dayList[0];
        let endTime = dayList[dayList.length-1]
          this.tjUpdatePriceFrom.inventorys[0].begin_date = startTime;
          this.tjUpdatePriceFrom.inventorys[0].end_date = endTime;
          this.tjUpdatePriceFrom.prices[0].begin_date = startTime;
          this.tjUpdatePriceFrom.prices[0].end_date = endTime;
          this.tjUpdatePriceFrom.prices[0].amount = price
          let houseId = this.roomsId.slice(0,this.roomsId.lastIndexOf('-'));
          this.tjUpdatePriceFrom.partner_pid = houseId;
          this.tjUpdatePriceFrom.partner_uid = houseId
          //status 0修改房态 1修改房价
          console.log('途家入参===>', this.tjUpdatePriceFrom)
          return inventory(this.tjUpdatePriceFrom);
      },
    // 修改价格
    async changePricePost() {
        // synchronousMt synchronousPig synchronousTj

        let dayList = this.selectData.length>0?this.selectData:this.noSlects;

        //已被预订的日期不允许改价
        /*if(this.selectDayList.find(item=>item.isYdRoom==0)){
            console.log('isYdRoom',this.selectDayList.find(item=>item.isYdRoom==0))
            return this.$message.warning('所选日期已被预订,不允许改价')
        }*/

      if (this.changePrice.iPriceNumber !== "") {
        this.changePrice = {
          houseId: this.roomsId || "",
          dPriceStartTime: this.selectData[0] || this.noSlects[0],
          dPriceEndTime:
            this.selectData[this.selectData.length - 1] ||
            this.noSlects[this.noSlects.length - 1],
          iPriceNumber: this.changePrice.iPriceNumber,
          iChannelIds: [0, 1, 2, 3, 4],
          iPriceStatus: "1"
        };
      } else {
        this.changePrice = {
          houseId: this.roomsId || "",
          dPriceStartTime: this.selectData[0] || this.noSlects[0],
          dPriceEndTime:
            this.selectData[this.selectData.length - 1] ||
            this.noSlects[this.noSlects.length - 1],
          iYoujiaPrice: this.changePrice.iYoujiaPrice, //悠家
          iMeituanPrice: this.changePrice.iMeituanPrice, //美团
          iTujiaPrice: this.changePrice.iTujiaPrice, //途家
          iXiaozhuPrice: this.changePrice.iXiaozhuPrice, //小猪
          iAibiyinPrice: this.changePrice.iAibiyinPrice, //爱彼迎
          iPriceStatus: "1"
        };
      }
    let houseInfo = this.singleList.find(item=>{return item.houseId==this.roomsId});
        console.log(houseInfo)

      const { data: res } = await fastUpdatePrice(this.changePrice);
      if (res.code !== 200)
         this.$message({
          message: res.msg,
          type: "error"
        });
      //修改小猪价格


        let pigData={
            housingId:this.roomsId.slice(0,this.roomsId.lastIndexOf('-')),
            id:houseInfo?.pigUserId,
            priceArray:[]
        }
        //小猪价格为空则使用一键改价
        dayList.forEach(item=>{
            let obj={}
            obj[item]=this.changePrice.iXiaozhuPrice?this.changePrice.iXiaozhuPrice:this.changePrice.iPriceNumber
            pigData.priceArray.push(obj)
        })
        pigData.priceArray=JSON.stringify(pigData.priceArray)
        console.log(pigData)
        console.log(houseInfo?.roomId)
        let roomId =houseInfo?.roomId|| houseInfo?.pigRoomId
        //houseInfo?.synchronousPig==1&&(this.changePrice.iPriceNumber||this.changePrice.iXiaozhuPrice)
        if(roomId&&(this.changePrice.iPriceNumber||this.changePrice.iXiaozhuPrice)){
            const { data: re } = await pigSyncPrice(pigData);
            if (re.code !== 200)
                this.$message({
                    message:'小猪错误:'+ re.msg,
                    type: "error"
                });
        }
        //houseInfo?.synchronousMt==1&&(this.changePrice.iPriceNumber || this.changePrice.iMeituanPrice)
        if(houseInfo?.productId&&(this.changePrice.iPriceNumber||this.changePrice.iMeituanPrice)){
            // 美团改价
            if( dayList.length>30){
                this.$message.warning('美团最多修改30天的房价');
                return ;
            }
            const { data: re } = await mtOperateRs({
                dateList: dayList.map(item => format("{y}{m}{d}",item)),
                price: this.changePrice.iPriceNumber || this.changePrice.iMeituanPrice,
                productId: houseInfo?.productId
            });
            if (re.code !== 200)
                this.$message({
                    message:'美团错误:'+ re.msg,
                    type: "error"
                });
        }
      // 修改途家价格
        console.log(houseInfo?.synchronousTj)
        if(houseInfo?.synchronousTj&&(this.changePrice.iPriceNumber || this.changePrice.iTujiaPrice)){
            if(this.hasSyncTjPrice){
                await this.getInventory(this.roomsId.slice(0,this.roomsId.lastIndexOf('-')),houseInfo?.vChannelTitle);
            }

            let  price= this.changePrice.iPriceNumber || this.changePrice.iTujiaPrice
            this.updateTjInventory(dayList,price).then(res=>{
                if(res.data.code!=200){
                    this.$message({
                        message:'途家错误:'+ res.data.msg,
                        type: "error"
                    });
                }
            })

        }

      this.changePrice = {
        houseId: "", //房源id
        dPriceStartTime: "", //开始时间
        dPriceEndTime: "", //结束时间
        iPriceNumber: "", //一键改价
        iYoujiaPrice: "", //悠家
        iMeituanPrice: "", //美团
        iTujiaPrice: "", //途家
        iXiaozhuPrice: "", //小猪
        iAibiyinPrice: "", //爱彼迎
        iPriceStatus: "1",
        iChannelIds: [0, 1, 2, 3, 4]
      };
      this.isSelect = false;
      this.drawer = false;
      this.housePriceAjax();
        console.log("end")
    },
    cancel() {
      this.changePrice = {
        houseId: "", //房源id
        dPriceStartTime: "", //开始时间
        dPriceEndTime: "", //结束时间
        iPriceNumber: "", //一键改价
        iYoujiaPrice: "", //悠家
        iMeituanPrice: "", //美团
        iTujiaPrice: "", //途家
        iXiaozhuPrice: "", //小猪
        iAibiyinPrice: "", //爱彼迎
        iPriceStatus: "1",
        iChannelIds: [0, 1, 2, 3, 4]
      };

      this.isSelect = false;
      this.drawer = false;
    },
    // 修改昵称
    async save() {
      const { data: res } = await updateHouseNickName({
        houseId: this.houseId,
          vHouseNickName: this.houseIdNickName
      });
      if (res.code !== 200)
        return this.$message({
          message: res.msg,
          type: "error"
        });
      this.houseId = "";
      this.houseIdNickName = "";
      this.dialogVisible_other = false;
      this.dialogVisible = false;
      this.housePriceAjax();
      return this.$message({
        message: res.msg,
        type: "success"
      });
    },

    // 分页
    handleSizeChange(val) {
      this.te.pageSize = val;
      this.selectBoxShow = false;
      this.housePriceAjax();
    },
    handleCurrentChange(val) {
      this.te.pageNum = val;
      this.selectBoxShow = false;
      this.housePriceAjax();
    },
    // 数据列表
    async housePriceAjax() {
      try {
          if(sessionStorage.getItem('userId')==1){
              delete this.formInline.cStewardId
          }
        const { data: res } = await housePrice(this.te, this.formInline);
        this.singleList = res.data.houseInfo;
        // // this.infos = res.data.statusList;\
        this.houseData=res.data.houseInfo;
          res.data.houseInfo.forEach(item=>{
              res.data.resultList.find(ite=>ite.houseId==item.houseId).synchronousMt=item.synchronousMt;
              res.data.resultList.find(ite=>ite.houseId==item.houseId).synchronousPig=item.synchronousPig
              res.data.resultList.find(ite=>ite.houseId==item.houseId).synchronousTj=item.synchronousTj
          })
        this.infos = res.data.resultList;

        this.total = res.data.total;
        /*let num=0;
        let nowTime=format('{y}-{m}-{d}',new Date())
        res.data.resultList.map(item=>{
          num+=  item.resultListSon.filter(ite=>ite.D==nowTime) .length;
        })
       this.houseNum=res.data.houseNum-num*/
          this.days.forEach(item=>{
              let num=0;
              res.data.resultList.map(it=>{
                  num+=  it.resultListSon.filter(ite=>ite.D==item.date).length;
              })
              item.houseNum=res.data.houseNum? res.data.houseNum-num:0
          })

        this.setCustomer();
      } catch (error) {
        console.log(error);
      }
      // this.setCustomerList();
    },
    goToday() {
      setTimeout(() => {
        //点击前往今天
        document.getElementById("room-status").scrollLeft =
          (this.daysDATA.totalDay - 1) * this.gridWidth;
      }, 50);
    },
    changeFlag(flag) {
      this.flag = flag;
    },
    // 左右滚动条滚动同步
    sysHandleScroll() {
      if (this.flag == 1) {
        this.$refs.externalForm.scrollTop = this.$refs.systemForm.scrollTop;
      }
    },
    exterHandleScroll() {
      if (this.flag == 2) {
        this.$refs.systemForm.scrollTop = this.$refs.externalForm.scrollTop;
      }
    },

    // init() {
    //   // 绑定滑动事件
    //   const roomsListDom = document.getElementById("rooms-list"); //左边的房源列表
    //   const roomsDom = document.getElementById("rooms"); //list

    //   roomsDom.onscroll = e => {
    //     if (roomsListDom.scrollTop !== e.target.scrollTop)
    //       roomsListDom.scrollTop = e.target.scrollTop;
    //   };
    //   roomsListDom.onscroll = e => {
    //     if (roomsListDom.scrollTop !== e.target.scrollTop)
    //       roomsDom.scrollTop = e.target.scrollTop;

    //   };

    //   // 设置左边数据
    //   // this.setCustomer();
    // },
    roomDownHandle(e, x, y, date, roomsId) {
      //鼠标按下
      const target = e.target;

      let houseInfo = this.gridData.find(item=>item.id==roomsId)

      // 清空之前的状态
      this.selectDataObj.forEach(v => {
        this.$set(v, "_isSelect", false);
      });
      this.selectDayList = [];
      this.selectDataObj = [];
      count = 0;
      if(houseInfo?.iChannelId!=0){
          return;
      }
      this.selectBoxPosition.left = target.offsetLeft;
      this.selectBoxPosition.top = y * 50 + 96;
      this.selectBoxPosition.x = x;
      this.selectBoxPosition.y = y;
      this.selectBoxPosition.min = target.offsetLeft;
      this.selectBoxPosition.max = target.offsetLeft + this.gridWidth;
      this.isSelect = true;
      this.selectBoxShow = true;
      this.selectData = [];
      this.roomsId = roomsId;
    },

    roomUpHandle(e) {

        let houseInfo = this.gridData.find(item=>item.id==this.roomsId);
        if(houseInfo?.iChannelId!=0){
            return;
        }
      //鼠标抬起
      // const roomsListDom = document.getElementById("rooms-line-box");
      const section =
        (this.selectBoxPosition.max - this.selectBoxPosition.min) /
        this.gridWidth;
      const list = this.gridData[this.selectBoxPosition.y].children;
      this.noSlects = [];

      for (let i = 0; i < section; i++) {
        this.noSlects.push(list[this.selectBoxPosition.x + i].date);
        this.selectDayList.push(list[this.selectBoxPosition.x + i])
      }
      // this.isSelect = false;
      console.log(
        e,
        `当前选择结果为：${this.selectData}, 房间id为：${this.roomsId}, 未选中日期为：${this.noSlects}，原因：已售出`
      );
      // if (this.selectData.length < 2) return;
        this.selectHouseObj = e.houseObj
      this.drawer = true;
    },
    roomMoveHandle(e, x, y, date) {
      count++;
      if (this.isSelect && count % 2 === 0) {
        if (e.target.offsetLeft > this.selectBoxPosition.min) {
          this.selectBoxPosition.max = e.target.offsetLeft + this.gridWidth;
        }
      }
      this.box_width = this.selectBoxPosition.max - this.selectBoxPosition.min;
      // console.log(this.box_width);
    },

    // 单房源
    setCustomer() {
      this.gridData = this.infos.map((v,index) => {
        const children = [];
          // console.log(v,'v')
        this.days.forEach(r => {
            r.isYdRoom=v.resultListSon.find(item => item.D == r.date)?.V, //是否已预订
          children.push({
              mDailyPrices: v.resultListSon.find(item => item.D == r.date)?.M || v.mDailyPrice,
              synchronousMt:v?.synchronousMt,
              synchronousPig:v?.synchronousPig,
              synchronousTj:v?.synchronousTj,
              houseObj:v,
              isYdRoom:v.resultListSon.find(item => item.D == r.date)?.V, //是否已预订
            ...r
          });
        });
         /* console.log({
              id: v.houseId,
              name: v.vChannelTitle,
              mDailyChannel: v.mDailyChannel,
              // img: v.vCoverPic,
              // nickName: v.vHouseNickName,
              iChannelId: v.iChannelId,
              children
          })*/
          let houseObj = this.houseData.find(item=>item.houseId==v.houseId);
        return {
          id: v.houseId,
          name: v.vChannelTitle,
          mDailyChannel: v.mDailyChannel,
          img:houseObj?.vCoverPic,
          // nickName: v.vHouseNickName,
          iChannelId: v.iChannelId,
          pigUserId:v.pigUserId,
          roomId:v.roomId,
          synchronousMt:houseObj?.synchronousMt,
          synchronousPig:houseObj?.synchronousPig,
          synchronousTj:houseObj?.synchronousTj,
            vHouseNickName:houseObj?.vHouseNickName,

          children
        };
      });
      this.setCheckIn();
      console.log(
        `表格数据拼装完成,耗时：${+new Date() - this.daysDATA.todayMs}ms`
      );
    },

    // setCloseroom(infos = []){

    // },
    setCheckIn(infos = []) {
      // 客户订房信息
      // 根据接口请求
      const begin = +new Date();
      infos = this.infos;
      this.gridData.forEach(grid => {
        infos.forEach(info => {
          if (info.houseId === grid.id) {
            grid.children.forEach(item => {
              this.$set(item, "_mDailyPrice", info.mDailyPrice);

              if (this._guestInfo) {
                this.$set(item, "_guestInfo", info._guestInfo);
              } else {
                item._guestInfo = info._guestInfo;
                // item._close = item2.V == 1;
              }
              // info.resultListSon.forEach(item2 => {
              //   if (item2.D.indexOf(item.date) !== -1) {
              //     if (item._isBuy) {
              //       this.$set(item, "_isBuy", item2.V == "0"); //是否已定
              //       this.$set(item, "_guestInfo", item2.M);
              //       // this.$set(item, "_close", item2.V == 1);
              //     } else {
              //       item._isBuy = item2.V == 0;
              //       item._guestInfo = item2.M;
              //       // item._close = item2.V == 1;
              //     }
              //   }
              // });
            });
          }
        });
      });
      console.log(`入住信息填充完成,耗时${+new Date() - begin}ms`);
    },
    setDaysData() {
      const oneDayMs = 86400000; //一天的时间
      const todayObj = new Date(); //今天的时间 Fri May 21 2021 14:10:26 GMT+0800 (中国标准时间)
      const todayMs = +new Date(); //当前的时间戳1621577377143
      const today = `${todayObj.getFullYear()}-${
        todayObj.getMonth() + 1 >= 9
          ? todayObj.getMonth() + 1
          : "0" + (todayObj.getMonth() + 1)
      }-${
        todayObj.getDate() > 9 ? todayObj.getDate() : "0" + todayObj.getDate()
      }`; //年月日的格式2021-05-21
      const multiple = 2; //前后两年
      const totalDay = 365; //天数
      const totalDayMs = todayMs + totalDay * oneDayMs; //当前时间戳 + 365 * 每天的时间戳
      const days = [];
      // 节假日 后端获取
      const holidays = [
        "2021-01-01",
        "2021-01-02",
        "2021-01-03",
        "2021-02-11",
        "2021-02-12",
        "2021-02-13",
        "2021-02-14",
        "2021-02-15",
        "2021-02-16",
        "2021-02-17",
        "2021-04-03",
        "2021-04-04",
        "2021-04-05",
        "2021-05-01",
        "2021-05-02",
        "2021-05-03",
        "2021-05-04",
        "2021-05-05",
        "2021-05-12",
        "2021-05-13",
        "2021-05-14",
        "2021-09-19",
        "2021-09-20",
        "2021-09-21",
        "2021-10-01",
        "2021-10-02",
        "2021-10-03",
        "2021-10-04",
        "2021-10-05",
        "2021-10-06",
        "2021-10-07"
      ];
      // 工作日 后端获取
      const weekdays = [
        "2021-01-01",
        "2021-02-07",
        "2021-02-20",
        "2021-04-25",
        "2021-05-08",
        "2021-09-26",
        "2021-10-09"
      ];
      const weekMap = {
        0: "日",
        1: "一",
        2: "二",
        3: "三",
        4: "四",
        5: "五",
        6: "六"
      };
      // 节假日明细
      // const festivaldays = [];
      let daysDATA = {
        days,
        todayMs,
        today,
        totalDay,
        multiple
      };
      let count = 0;
      let begin = +new Date();
      for (let i = 0; i < totalDay * multiple; i++) {
        count++;
        const thatDay = new Date(totalDayMs - count * oneDayMs);
        const date = `${thatDay.getFullYear()}-${
          thatDay.getMonth() + 1 > 9
            ? thatDay.getMonth() + 1
            : "0" + (thatDay.getMonth() + 1)
        }-${
          thatDay.getDate() > 9 ? thatDay.getDate() : "0" + thatDay.getDate()
        }`; //当前单元格的年月日信息
          console.log()
        const obj = {
          date,
          dateSp: date.split("-"),
          dateNum: +`${thatDay.getFullYear()}${thatDay.getMonth() +
            1}${thatDay.getDate()}`,
          day: thatDay.getDate(),
          month: thatDay.getMonth() + 1,
          day: thatDay.getDate(),
          week: thatDay.getDay() === 0 ? "7" : thatDay.getDay(),
          weekStr: weekMap[thatDay.getDay()], //一、二、三、四、五、六、日
          isToday: date === today, //是否是今天
          // isFestival: 1,
          isWeek: thatDay.getDay() === 0 || thatDay.getDay() === 6,
          isHolidays: holidays.indexOf(date) !== -1, //是否节假日
          isWeekdays: weekdays.indexOf(date) !== -1 //是否工作日
        };
        days.unshift(obj);
      }

      this.daysDATA = daysDATA;
      this.days = days;
      console.log(`生成日历数据已完成,耗时：${+new Date() - begin}ms`);
      return daysDATA;
    },
    housrInfo(e) {
      this.dialogVisible = true;
      console.log(e);
       this.houseId = e.id;
      this.home_title = e.name;
       this.nickName = e.vHouseNickName||e.name;
       this.home_img=e.img;
    },
    handleClose(done) {
      done();
    },
    chengename() {
      this.dialogVisible_other = true;
    },
    TabsClick(tab, event) {
      console.log(tab, event);
    },
    handleCloseLeft(done) {
      done();
    },
    reset() {
      this.formInline.title = "";
      this.formInline.number = "";
      this.housePriceAjax();
      this.page = {
        year: "2021",
        month: "7",
        Num: "2",
        pageNum: 1,
        pageSize: 5
      };
    },
    onSubmit() {
      this.housePriceAjax();
      this.page = {
        year: "2021",
        month: "7",
        Num: "2",
        pageNum: 1,
        pageSize: 5
      };
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollDs, true);
  }
};
</script>

<style lang="less" scoped>

body,
html,
#app {
  width: 100%;
  height: 100%;
}
.RoomStatus {
  width: 100%;
  height: calc(100% - 50px);
}
.loading {
  display: flex;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background: #fff;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  img {
    width: 600;
    height: 600px;
  }
}
.main {
  width: 100%;
  height: 92%;

  .content {
    display: flex;
    width: 100%;
    height: 100%;
    .left {
      width: 180px;
      height: 100%;
      flex: none;
      background: orange;
    }
    .right {
      flex: 1;
      position: relative;
      .go-today {
        position: absolute;
        z-index: 10;
        left: 55%;
        margin-left: -21px;
        bottom: 20px;
        width: 42px;
        height: 42px;
        font-size: 12px;
        color: #fff;
        font-weight: 400;
        border-radius: 50%;
        background-color: #2c80f0;
        text-align: center;
        line-height: 42px;
        cursor: pointer;
      }
      .rooms-info {
        border-top: 1px solid #e1e1e1;
        border-left: 1px solid #e1e1e1;
        border-bottom: 1px solid #e1e1e1;
        // padding-bottom: 50px;
        // height: 688px;
        height: 100%;
        width: 245px;
        overflow: hidden;
        position: absolute;
        // background: #f6f6f6;
        z-index: 1;
        .title {
          text-align: center;
          height: 96px;
          display: flex;
          line-height: 96px;
          font-size: 24px;
          color: #000;
          font-weight: 400;
          border-bottom: 1px solid #b4cdff;
          border-right: 1px solid #b4cdff;
          .title_left {
            width: 144px;
            flex: none;
          }
          .title_right {
            border-left: 1px solid #e1e1e1;
            // width: 99px;
            flex: 1;
            font-size: 16px;
            color: #666666;
          }
        }
        .rooms-list {
          // padding-bottom: 50px;
          height: calc(100% - 110px);

          overflow-y: auto;
          overflow-x: hidden;
          .room-item:hover {
            transform: translateZ(20px);
          }
          .room-item {
            cursor: pointer;
            background-color: #fff;
            height: 50px;
            border-bottom: 1px solid #b1d2ff;
            border-right: 1px solid #b1d2ff;
              .roomTitle{
                  width: 144px;
                  position: relative;
                  .channelImg{
                      width: 30px;
                      height: 30px;
                      border-radius: 50%;
                      position:absolute;
                      right: 0;
                      top: 10px;
                  }
              }
            .room-item-text {
              float: left;
              width: 144px;
              height: 32px;
              margin-top: 10px;
              padding: 0 10px;
              // padding: 10px 5px;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
            .room-item-price {
              float: left;
              // right: 0px;
              width: calc(100% - 144px);
              height: 50px;
              padding: 10px 0px;
              // line-height: 50px;
              text-align: center;
              border-left: 1px solid #b1d2ff;
              top: 0px;
              .money {
                color: #171a1e;
                font-size: 12px;
              }
              .money_currency {
                font-size: 12px;
                color: #666666;
              }
            }
          }
        }

        .gridDataList {
          height: 36px;
          line-height: 36px;
          padding-left: 13px;
          font-size: 14px;
          color: #171a1e;
          background: rgba(64, 158, 255, 0.1);
          border-right: 1px solid #b1d2ff;
          border-bottom: 1px solid #b1d2ff;
        }
      }
      .room-status {
        // background-color: #f6f6f6;
        // padding-bottom: 50px;
        // overflow: hidden;
        width: 90%;
        height: 100%;
        overflow: auto;
        position: absolute;
        top: 0;
        right: 0;
        left: 245px;
        bottom: 0;
        border-right: 1px solid #b1d2ff;
        .calendar {
          height: 97px;
          display: flex;
          flex-wrap: nowrap;
          position: absolute;
          z-index: 13;
          background: #fff;
          left: 0;
          top: 0;
          border-top: 1px solid #b1d2ff;
          border-bottom: 1px solid #b1d2ff;

          div {
            flex: none;
            color: #a2a2a2;
            font-size: 12px;
            text-align: center;
            .day {
              position: relative;
              color: #666666;
              height: 30px;
              line-height: 30px;
              .isHolidays {
                position: absolute;
                // border-radius: 50%;
                // color: #fff;
                top: 0;
                right: 0;
                width: 24px;
                height: 24px;
                // text-align: center;
                // line-height: 14px;
                // font-size: 10px;
                // background: #eb5757;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }
            .week {
              border-bottom: 1px solid #d9e6ff;
              padding-bottom: 5px;
              height: 30px;
              line-height: 30px;
              &.weekend {
                color: #ff5147;
              }
            }
            .today {
              border-bottom: 1px solid #d9e6ff;
              padding-bottom: 5px;
              height: 30px;
              line-height: 30px;
              color: #2f80ed;
            }
            .surplus {
              width: 51px;
              height: 36px;
              line-height: 36px;
              color: #111112;
              border-right: 1px solid #d9e6ff;
            }
          }
        }
        .rooms {
          border-left: 1px solid #b1d2ff;
          height: 100%;
          padding-top: 97px;
          position: relative;
          overflow-y: auto;
          overflow-x: hidden;
          color: #fff;
          .select-box {
            height: 50px;
            width: 50px;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 12;
            border: 2px solid #eb8327;
            border-radius: 3px;
            pointer-events: none;
          }
          .rooms-line {
            position: relative;
            height: 50px;
            border-bottom: 1px solid #b4cdff;
            display: flex;
            user-select: none;
            .rooms-item {
              // border-right: 1px solid #b1d2ff;
              // border-bottom: 1px solid #b1d2ff;
              padding: 5px;
              height: 100%;
              position: absolute;
              z-index: 2;
              flex: none;
              line-height: 40px;
              text-align: center;
              color: #000;
              background: #fff;
              background: url("../../image/shadow.png") 0 0 no-repeat;
              background-size: cover;
              .check-in_top {
                position: absolute;
                top: 6px;
                left: 50%;
                transform: translateX(-50%);

                // line-height: 24px;
                font-size: 12px;
                color: #000;
              }
              .check-in_bottom {
                position: absolute;
                bottom: 6px;
                left: 50%;
                transform: translateX(-50%);
                // line-height: 24px;
                font-size: 12px;
                color: #000;
              }
              &.rooms-real {
                border-right: 1px solid #b1d2ff;
                border-bottom: 1px solid #b1d2ff;
                background: url("../../image/off.png") 0 0 no-repeat;
              }
              &.rooms-pitch {
                border-right: 0;
                // border-bottom: 1px solid #b1d2ff;
              }
            }
            // .check-in {
            //   z-index: 6;
            //   position: absolute;
            //   padding: 3px 0 0 3px;
            //   bottom: 0;
            //   height: 40px;
            //   line-height: 35px;
            //   text-align: center;
            //   border-radius: 3px;

            //   font-size: 12px;
            //   color: #fff;
            //   // .check-in_top {
            //   //   border-radius: 5px 5px 0 0;
            //   //   line-height: 17px;
            //   //   font-size: 12px;
            //   // }
            //   .check-in_bottom {
            //     border-radius: 0 0 5px 5px;
            //     line-height: 17px;
            //     font-size: 12px;
            //   }
            // }
            // .red {
            //   background-color: red;
            // }
            // .green {
            //   background-color: #219653;
            // }
            // .grey {
            //   background-color: #f6f6f6;
            // }
            // .yellow {
            //   background-color: #f6b439;
            // }
          }
        }
      }
    }
  }
}
.dialog-footer {
  .add_new_btn {
    margin-left: 24px;
    width: 72px;
    height: 36px;
    background-color: #f6b439;
    border: 1px solid #f6b439;
    box-sizing: border-box;
    border-radius: 4px;
  }
  .cancel {
    width: 72px;
    height: 36px;
    background-color: #f2f2f2;
    border: 1px solid #e1e1e1;
    box-sizing: border-box;
    border-radius: 4px;
  }
}
/deep/.el-dialog__header {
  padding: 0;
}
/deep/.el-dialog__body {
  padding: 15px;
  .info {
    height: 116px;
    .info_top {
      padding-bottom: 15px;
      height: 80px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      .top_left {
        float: left;
        height: 64px;
        width: 64px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .top_right {
        font-weight: bold;
        font-size: 16px;
        width: 250px;
        float: right;
        height: 44px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
    .info_bottom {
      padding-top: 15px;
      height: 37px;
      .bottom_left {
        font-size: 16px;
        width: 270px;
        float: left;
        overflow: hidden; //隐藏
        white-space: nowrap; //显示一行
        text-overflow: ellipsis; //。。。
      }
      .bottom_right {
        float: right;
      }
    }
  }
  .userNickName {
    line-height: 60px;
    padding: 0 15px;
    padding-top: 50px;
    height: 120px;
    .userNickName_input {
      float: right;
      width: 267px;
    }
  }
}
/deep/.el-dialog {
  border-radius: 12px;
}

/deep/.el-drawer__header {
  padding: 0;
  margin-bottom: 0;
}
/deep/.el-drawer__open .el-drawer.rtl {
  width: 400px !important;
  box-shadow: -4px 0px 4px rgba(0, 0, 0, 0.1);
}
/deep/.el-tabs__header {
  margin: 0;
}

/deep/.el-tabs__nav-wrap {
  padding-top: 14px;
  height: 54px;
}
/deep/.el-tabs__item.is-active {
  color: #f6b439;
}
/deep/.el-tabs__active-bar {
  background-color: #f6b439;
}
/deep/.el-tabs__item:hover {
  color: #f6b439;
}
.hoursInfo_box {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 20px 30px;
  .hoursInfo_title {
    width: 330px;
    height: 42px;
    font-size: 16px;
    line-height: 21px;
    font-weight: bold;
    color: #171a1e;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    margin-bottom: 15px;
    div {
      float: right;
      font-size: 16px;
      font-weight: normal;
      color: #999999;
    }
  }
  .hoursInfo_message {
    font-size: 14px;
    color: #333333;
    margin-bottom: 15px;
  }
  .hoursInfo_date {
    position: relative;
    width: 340px;
    height: 36px;
    border: 1px solid #e1e1e1;
    border-radius: 4px;
    margin-bottom: 20px;
    line-height: 34px;
    padding: 0 10px;
    i {
      font-size: 20px;
      position: absolute;
      right: 12px;
      bottom: 3px;
    }
  }
  /deep/.el-form-item {
    height: 36px;
    margin-bottom: 15px;
    color: #000000;
    .el-form-item__label {
      height: 36px;
    }
    .el-form-item__content {
      height: 36px;
      .el-input {
        height: 36px;
        .el-input__inner {
          height: 36px;
        }
      }
    }
    .el-select {
      width: 100%;
    }
    .el-input__icon {
      line-height: 36px;
    }
  }
  .footer {
    position: fixed;
    bottom: 30px;
    right: 30px;
    height: 36px;
  }
  .add_new_btn {
    height: 36px;
    width: 72px;
    margin-left: 24px;
    background-color: #f6b439;
    border: 1px solid #f6b439;
  }
  .cancel {
    height: 36px;
    width: 72px;
    background: #f2f2f2;
    border: 1px solid #e1e1e1;
  }
}
.paging {
  background-color: #fff;
  z-index: 1;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 9px;
}
.el-radio {
  margin-right: 30px;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #f6b439;
}
/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #f6b439;
  background: #f6b439;
  width: 24px;
  height: 24px;
}
/deep/.el-radio__label {
  font-size: 16px;
}
/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #f6b439;
}
/deep/.el-radio__inner {
  width: 24px;
  height: 24px;
}
/deep/.el-radio__inner::after {
  width: 10px;
  height: 10px;
}
/deep/.demo-form-inline {
  margin-bottom: 20px;
  .el-input__inner {
    width: 200px;
    height: 36px;
    font-size: 14px;
  }
  .left_margin {
    margin-left: 26px;
  }
  .inquire {
    width: 72px;
    height: 36px;
    margin-top: 2px;
    margin-left: -12px;
  }
  .el-button + .el-button {
    margin-left: 24px;
    width: 72px;
    height: 36px;
    background: #f6b439;
    border: 1px solid #f6b439;
  }
}
</style>
